import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  fetchUserStart,
  fetchUserSuccess,
  fetchUserError,
} from "../../redux/slices/userSlice";
import ProfileService from "../../services/Profile";
import { useNavigate } from "react-router-dom";

export default function ProfileFunction() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const userData = useSelector((state) => state.user.userData);
  const isLoading = useSelector((state) => state.user.isLoading);

  useEffect(() => {
    if (userData) return;

    const loadUserData = async () => {
      try {
        dispatch(fetchUserStart());

        const response = await ProfileService.getProfile();

        const profileData = response.data?.data;

        const userData = {
          ...profileData?.finduser,
          is_ban: profileData?.is_ban ?? false,
        };

        dispatch(fetchUserSuccess(userData));
      } catch (error) {
        console.error("Error fetching user data:", error);

        dispatch(
          fetchUserError(
            error?.message ||
              error?.toString() ||
              "couldn't find account's information",
          ),
        );

        if (
          error.status === 400 ||
          error.status === 401 ||
          error.status === 402 ||
          error.status === 403
        ) {
          navigate("/login");
        }
      }
    };

    loadUserData();
  }, [dispatch, navigate, userData]);
}
